/*
 * @Author: songyzh
 * @Date: 2020-08-19 09:56:37
 * @LastEditors: songyzh
 * @LastEditTime: 2020-11-08 21:23:29
 */
import getConfig from '@/utils/get-config';
import Vue from 'vue';
import { initAxiosInstance } from '@/api/base';

export default async () => {
  const appConfig = await getConfig();
  const { config, fullConfig } = appConfig;

  const { SYSNAME } = fullConfig;
  Vue.prototype.$appConfig = fullConfig;
  document.title = SYSNAME;

  // 注册 axios 实例
  initAxiosInstance(config);
};
